<template>
  <!-- C-7 (XOL-596 UX): the in-flight indicator of an explicit workflow COMMAND
       (Rejecting…, Locking… / Unlocking…, Complete Step). The approval controls are
       fields and show none (the C-12 card carries their Pending, Saving, Saved). Always
       rendered, with a minimum width, so it never moves the row (XOL-416); empty
       unless a command is running. It sits INSIDE the control's el-form-item,
       after the control, never in an el-form-item of its own. -->
  <span class="cmd-saving" role="status"><template v-if="busy"><i class="el-icon-loading" aria-hidden="true"></i> {{label || defaultLabel}}</template></span>
</template>

<script>
import { copyText } from '@/lib/requestSyncCopy'

export default {
  name: 'cmd-saving',

  props: {
    busy: {
      type: Boolean,
      default: false
    },

    // "Rejecting…" for the close-permanently command; "Saving…" by default.
    label: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      defaultLabel: copyText('requestSync.status.saving')
    }
  }
}
</script>

<style scoped>
.cmd-saving { display: inline-block; min-width: 5.5em; vertical-align: middle; font-size: 12px; }

/* XOL-596: the C-12 card stops every animation under reduced motion; so does this. The
   word ("Rejecting…", "Locking…") carries the meaning. */
@media (prefers-reduced-motion: reduce) {
  .cmd-saving .el-icon-loading { animation: none; }
}
</style>
